// `Atom` is the base class that manages states and subscriptions
export default class Atom {
  // the value property is protected because it needs to be manually
  // assigned in the constructor (because of inheritance quirks)
  constructor(value) {
    this.value = value;

    // a set of unique callbacks
    this.listeners = new Set();
  }
  
  // simple method for returning the state. This could return a deep
  // copy if you wanted to be extra cautious.
  snapshot() {
    return this.value;
  }
  
  // the emit method is what updates all the listeners with the new state
  emit() {
    for (const listener of this.listeners.values()) {
      listener(this.value);
    }
  }

  // the canonical way to set state. It uses object
  // equality to prevent unnecessary renders
  setState(value) {
    if (this.value === value) return;

    this.value = value;
    // after updating the value, let all the listeners know there's
    // been a state change
    this.emit();
  }

  // the subscribe method lets consumers listen for state updates. Calling
  // the `disconnect` method will stop the callback from being called in
  // the future.
  subscribe(callback) {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }
};